export default {
    CANNOT_ACCESS_LOOTBAG: 'Вы не можете получить доступ к этому мешку прямо сейчас.',
    REQUIRES_ACHIEVEMENT: 'Для экипировки этого предмета требуется секретное достижение.',
    REQUIRES_QUEST: 'Чтобы экипировать этот предмет, необходимо выполнить {{quest}}.',
    SKILL_LEVEL_REQUIREMENT_EQUIP:
        'Для его использования ваш {{skill}} должен быть не ниже {{level}}.',
    TOTAL_LEVEL_REQUIREMENT:
        'Чтобы экипировать этот предмет, ваш общий уровень должен быть не ниже {{level}}.'
} as const;
